import { defineMessages } from 'react-intl';

export default defineMessages({
  sectionTitle: {
    id: 'fastCover.stepOther.sectionTitle',
    defaultMessage: 'Section 8 - Other Claims',
  },
  yes: {
    id: 'fastCover.stepOther.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.stepOther.no',
    defaultMessage: 'No',
  },
  isThereAnyThingElseYouWouldLikeToClaimFor: {
    id: 'fastCover.stepOther.isThereAnyThingElseYouWouldLikeToClaimFor',
    defaultMessage: 'Is there anything else you would like to claim for?',
  },
  areYouClaimingForPersonalLiability: {
    id: 'fastCover.stepOther.areYouClaimingForPersonalLiability',
    defaultMessage: 'Are you claiming for Personal Liability?',
  },
  areYouClaimingForGolfPackOptionalCover: {
    id: 'fastCover.stepOther.areYouClaimingForGolfPackOptionalCover',
    defaultMessage: 'Are you claiming for Golf Pack Optional Cover?',
  },
  areYouClaimingForBicyclePackOptionalCover: {
    id: 'fastCover.stepOther.areYouClaimingForBicyclePackOptionalCover',
    defaultMessage: 'Are you claiming for Bicycle Pack Optional Cover?',
  },
  toAssistYourClaim: {
    id: 'fastCover.stepOther.toAssistYourClaim',
    defaultMessage: 'To assist your claim:',
  },
  toAssistYourClaimDetail1: {
    id: 'fastCover.stepOther.toAssistYourClaim',
    defaultMessage: 'We may need the below documents, please provide those that are applicable.',
  },
  toAssistYourClaimDetail2: {
    id: 'fastCover.stepOther.toAssistYourClaim',
    defaultMessage: 'We may contact you to request further documentation',
  },
  document: {
    id: 'fastCover.stepOther.document',
    defaultMessage: 'Documents',
  },
  document1: {
    id: 'fastCover.stepOther.document1',
    defaultMessage: 'A copy of your Travel Itinerary',
  },
  document2: {
    id: 'fastCover.stepOther.document2',
    defaultMessage: 'A copy of all relevant invoices being claimed',
  },
  document3: {
    id: 'fastCover.stepOther.document3',
    defaultMessage: 'Any other relevant supporting documents',
  },
  document4: {
    id: 'fastCover.stepOther.document4',
    defaultMessage: 'A copy of any incident report relevant to the cause of the claim',
  },
  document5: {
    id: 'fastCover.stepOther.document5',
    defaultMessage: 'Copy of police report ',
  },
  document6: {
    id: 'fastCover.stepOther.document6',
    defaultMessage: 'A damage/repair report for damaged Golf equipment or bicycle',
  },
  document7: {
    id: 'fastCover.stepOther.document7',
    defaultMessage: 'Purchase receipt or other evidence of ownership for each item claimed',
  },
  provideExplanation: {
    id: 'fastCover.stepOther.provideExplanation',
    defaultMessage: 'If you cannot provide any of the above documents, please provide an explanation why you are unable to.',
  },
  pleaseTellUs: {
    id: 'fastCover.stepOther.pleaseTellUs',
    defaultMessage: 'If your item claimed was lost, stolen, damaged or delayed please tell us:',
  },
  howItHappened: {
    id: 'fastCover.stepOther.howItHappened',
    defaultMessage: '1. How it happened',
  },
  whereYouWereInRelationToTheItem: {
    id: 'fastCover.stepOther.whereYouWereInRelationToTheItem',
    defaultMessage: '2. Provide details of where you were in relation to the item at the time of loss, theft or damage',
  },
  anyThingAdditionalToAdd: {
    id: 'fastCover.stepOther.anyThingAdditionalToAdd',
    defaultMessage: 'Do you have any further details to add?',
  },
  areYouClaimingFor: {
    id: 'fastCover.stepOther.areYouClaimingFor',
    defaultMessage: 'Are you claiming for',
  },
  loss: {
    id: 'fastCover.stepOther.loss',
    defaultMessage: 'Loss',
  },
  theft: {
    id: 'fastCover.stepOther.theft',
    defaultMessage: 'Theft',
  },
  damage: {
    id: 'fastCover.stepOther.damage',
    defaultMessage: 'Damage',
  },
  delay: {
    id: 'fastCover.stepOther.delay',
    defaultMessage: 'Delay',
  },
  whoDidYouReportThisTo: {
    id: 'fastCover.stepOther.whoDidYouReportThisTo',
    defaultMessage: 'Who did you report this to?',
  },
  police: {
    id: 'fastCover.stepOther.police',
    defaultMessage: 'Police',
  },
  hotelManagement: {
    id: 'fastCover.stepOther.hotelManagement',
    defaultMessage: 'Hotel Management',
  },
  cruiseShip: {
    id: 'fastCover.stepOther.cruiseShip',
    defaultMessage: 'Cruise Ship',
  },
  airline: {
    id: 'fastCover.stepOther.airline',
    defaultMessage: 'Airline',
  },
  tourGuide: {
    id: 'fastCover.stepOther.tourGuide',
    defaultMessage: 'Tour Guide',
  },
  other: {
    id: 'fastCover.stepOther.other',
    defaultMessage: 'Other',
  },
  notReported: {
    id: 'fastCover.stepOther.notReported',
    defaultMessage: 'Not Reported',
  },
  otherDescription: {
    id: 'fastCover.stepOther.otherDescription',
    defaultMessage: 'If other, please describe',
  },
  reportReferenceNumber: {
    id: 'fastCover.stepOther.reportReferenceNumber',
    defaultMessage: 'Report Reference Number',
  },
  expensesClaimed: {
    id: 'fastCover.stepOther.expensesClaimed',
    defaultMessage: 'Expenses Claimed',
  },
  expensesClaimedOther: {
    id: 'fastCover.stepOther.expensesClaimed',
    defaultMessage: 'Other Expenses Claimed',
  },
  expensesClaimedTitle: {
    id: 'fastCover.stepOther.expensesClaimedTitle',
    defaultMessage: 'Expense {index}',
  },
  addOtherExpense: {
    id: 'fastCover.stepOther.addOtherExpense',
    defaultMessage: 'Add Other Expense',
  },
  addExpense: {
    id: 'fastCover.stepOther.addExpense',
    defaultMessage: 'Add Expense',
  },
  dateOfExpense: {
    id: 'fastCover.stepOther.dateOfExpense',
    defaultMessage: 'Date of Expense',
  },
  description: {
    id: 'fastCover.stepOther.description',
    defaultMessage: 'Description of expense claimed',
  },
  amount: {
    id: 'fastCover.stepOther.amount',
    defaultMessage: 'Amount',
  },
  currency: {
    id: 'fastCover.stepOther.currency',
    defaultMessage: 'Currency',
  },
  amountClaimed: {
    id: 'fastCover.stepOther.amountClaimed',
    defaultMessage: 'Amount claimed',
  },
  australianDollars: {
    id: 'fastCover.stepOther.australianDollars',
    defaultMessage: 'Australian dollars',
  },
  supportingDocumentsAttached: {
    id: 'fastCover.stepOther.supportingDocumentsAttached',
    defaultMessage: 'Supporting Documents Attached?',
  },
  supportingDocumentsAttachedNote: {
    id: 'fastCover.stepOther.supportingDocumentsAttachedNote',
    defaultMessage: 'You can attach supporting documents later in this form',
  },
  isRequired: {
    id: 'fastCover.stepOther.isRequired',
    defaultMessage: '\'{defaultMessage}\' is required',
  },
  costClaimedTableRequired: {
    id: 'fastCover.stepOther.costClaimedTableRequired',
    defaultMessage: 'Costs Claimed table fields are required fields.',
  },
  golfExpensesClaimed: {
    id: 'fastCover.stepOther.golfExpensesClaimed',
    defaultMessage: 'Golf Expenses Claimed',
  },
  golfExpense: {
    id: 'fastCover.stepOther.golfExpenses',
    defaultMessage: 'Golf Expense {index}',
  },
  addGolfExpense: {
    id: 'fastCover.stepOther.addGolfExpense',
    defaultMessage: 'Add Golf Expense',
  },
  bicycleExpensesClaimed: {
    id: 'fastCover.stepOther.bicycleExpensesClaimed',
    defaultMessage: 'Bicycle Expenses Claimed',
  },
  bicycleExpense: {
    id: 'fastCover.stepOther.bicycleExpense',
    defaultMessage: 'Bicycle Expense {index}',
  },
  addBicycleExpense: {
    id: 'fastCover.stepOther.addBicycleExpense',
    defaultMessage: 'Add Bicycle Expense',
  },
  other1: {
    id: 'fastCover.stepOther.other1',
    defaultMessage: 'A copy of any incident report relevant to the cause of the claim',
  },
  other2: {
    id: 'fastCover.stepOther.other1',
    defaultMessage: 'A copy of all relevant invoices being claimed',
  },
  other3: {
    id: 'fastCover.stepOther.other1',
    defaultMessage: 'Any other relevant supporting documents',
  },

  nameOfDeceased: {
    id: 'fastCover.stepOther.namOfDeceased',
    defaultMessage: 'Name of Deceased / Patient / Relation',
  },

  theClaimIsBeingMadeUnder: {
    id: 'fastCover.stepOther.theClaimIsBeingMadeUnder',
    defaultMessage: 'The claim is being made under',
  },

  dateOfInjury: {
    id: 'fastCover.stepOther.dateOfInjury',
    defaultMessage: 'Date of  Injury / Death',
  },

  checkNameOfDeceased: {
    id: 'fastCover.stepOther.checkNameOfDeceased',
    defaultMessage: 'Nature of Dismemberment',
  },

  placeWhereAccidentHappened: {
    id: 'fastCover.stepOther.placeWhereAccidentHappened',
    defaultMessage: 'Place where accident occurred',
  },

  describeWhereTheAccidentOccurred: {
    id: 'fastCover.stepOther.describeWhereTheAccidentOccurred',
    defaultMessage: 'Describe where the accident occurred',
  },

  describeHowTheAccidentOccurred: {
    id: 'fastCover.stepOther.describeHowTheAccidentOccurred',
    defaultMessage: 'Describe how the accident occurred',
  },

  accidentalDeath: {
    id: 'fastCover.stepOther.accidentalDeath',
    defaultMessage: 'Accidental Death',
  },

  accidentalDismemberment: {
    id: 'fastCover.stepOther.accidentalDismemberment',
    defaultMessage: 'Accidental Dismemberment',
  },

  rightHand: {
    id: 'fastCover.stepOther.rightHand',
    defaultMessage: 'Right Hand',
  },

  leftHand: {
    id: 'fastCover.stepOther.leftHand',
    defaultMessage: 'Left Hand',
  },

  bothHands: {
    id: 'fastCover.stepOther.bothHands',
    defaultMessage: 'Both Hands',
  },

  rightFoot: {
    id: 'fastCover.stepOther.rightFoot',
    defaultMessage: 'Right Foot',
  },

  leftFoot: {
    id: 'fastCover.stepOther.leftFoot',
    defaultMessage: 'Left Foot',
  },

  bothFeet: {
    id: 'fastCover.stepOther.bothFeet',
    defaultMessage: 'Both Feet',
  },

  sightOfRightEye: {
    id: 'fastCover.stepOther.sightOfRightEye',
    defaultMessage: 'Sight of Right Eye',
  },

  sightOfLeftEye: {
    id: 'fastCover.stepOther.sightOfLeftEye',
    defaultMessage: 'Sight of Left Eye',
  },

  sightOfBothEyes: {
    id: 'fastCover.stepOther.sightOfBothEyes',
    defaultMessage: 'Sight of Both Eyes',
  },

  areYouClaimingForAccidentalDeathAndDismemberment: {
    id: 'fastCover.stepOther.areYouClaimingForAccidentalDeathAndDismemberment',
    defaultMessage: 'Are you claiming for Accidental Death & Dismemberment?',
  },

  areYouClaimingForRepatriationExpenses: {
    id: 'fastCover.stepOther.areYouClaimingForBurialOrRepatriationExpenses',
    defaultMessage: 'Are you claiming for Repatriation expenses?',
  },

  areYouClaimingForBurialExpenses: {
    id: 'fastCover.stepOther.areYouClaimingForBurialOrRepatriationExpenses',
    defaultMessage: 'Are you claiming for Burial expenses?',
  },

  benefitAreYouClaimingFor: {
    id: 'fastCover.stepOther.benefitAreYouClaimingFor',
    defaultMessage: 'Which Benefit are you claiming for?',
  },

  localBurial: {
    id: 'fastCover.stepOther.localBurial',
    defaultMessage: 'Local Burial',
  },

  repatriation: {
    id: 'fastCover.stepOther.repatriation',
    defaultMessage: 'Repatriation',
  },

  assistance: {
    id: 'fastCover.stepOther.assistance',
    defaultMessage: 'Assistance Company/Claims Administrator Approval Number',
  },

  dateApproved: {
    id: 'fastCover.stepOther.dateApproved',
    defaultMessage: 'Date Approved',
  },

  causeOfDeath: {
    id: 'fastCover.stepOther.causeOfDeath',
    defaultMessage: 'Cause Of Death',
  },

  dateOfDeath: {
    id: 'fastCover.stepOther.dateOfDeath',
    defaultMessage: 'Date Of Death',
  },

  stateOfDeath: {
    id: 'fastCover.stepOther.stateOfDeath',
    defaultMessage: 'State Of Death',
  },

  countryOfDeath: {
    id: 'fastCover.stepOther.countryOfDeath',
    defaultMessage: 'Country Of Death',
  },

  wasTheMemberHospitalized: {
    id: 'fastCover.stepOther.wasTheMemberHospitalized',
    defaultMessage: 'Was the Member Hospitalized',
  },

  from: {
    id: 'fastCover.stepOther.from',
    defaultMessage: 'From',
  },

  to: {
    id: 'fastCover.stepOther.to',
    defaultMessage: 'To',
  },

  nameOfFuneralServiceProvider: {
    id: 'fastCover.stepOther.nameOfFuneralServiceProvider',
    defaultMessage: 'Name of Funeral Service Provider',
  },

  costOfLocalBurial: {
    id: 'fastCover.stepOther.costOfLocalBurial',
    defaultMessage: 'Cost of Local Burial',
  },

  invoiceNumber: {
    id: 'fastCover.stepOther.invoiceNumber',
    defaultMessage: 'Invoice Number',
  },

  familyMemberProvidingInformation: {
    id: 'fastCover.stepOther.familyMemberProvidingInformation',
    defaultMessage: 'Family Member providing information (Claimant)',
  },

  relationshipToMember: {
    id: 'fastCover.stepOther.relationshipToMember',
    defaultMessage: 'Relationship to Member',
  },

  address: {
    id: 'fastCover.stepOther.address',
    defaultMessage: 'Address',
  },

  cityOrTown: {
    id: 'fastCover.stepOther.cityOrTown',
    defaultMessage: 'City Or Town',
  },

  country: {
    id: 'fastCover.stepOther.country',
    defaultMessage: 'Country',
  },

  postalCode: {
    id: 'fastCover.stepOther.postalCode',
    defaultMessage: 'Postal Code',
  },

  phoneNumber: {
    id: 'fastCover.stepOther.phoneNumber',
    defaultMessage: 'Phone Number',
  },
  checkEventDate: {
    id: 'fastCover.stepOther.checkEventDate',
    defaultMessage: "'{defaultMessage}' cannot be in the future.",
  },

  expenseFor: {
    id: 'fastCover.stepOther.expenseFor',
    defaultMessage: 'Expense For',
  },
  descriptionOfExpense: {
    id: 'fastCover.stepOther.descriptionOfExpense',
    defaultMessage: 'Description of Expense',
  },
  dateOfExpenses: {
    id: 'fastCover.stepOther.dateOfExpenses',
    defaultMessage: 'Date of Expense',
  },
  amountCreditedOrRefunded: {
    id: 'fastCover.stepOther.amountCreditedOrRefunded',
    defaultMessage: 'Amount credited/refunded',
  },
  haveYouReceivedAnyCreditOrRefundFromTheServiceProvider: {
    id: 'fastCover.stepOther.haveYouReceivedAnyCreditOrRefundFromTheServiceProvider',
    defaultMessage: 'Have you received any credit or refund from the service provider?',
  },
  itemWithIdx: {
    id: 'fastCover.stepOther.itemWithIdx',
    defaultMessage: 'Item(s) {idx}',
  },
  addItem: {
    id: 'fastCover.stepOther.addItem',
    defaultMessage: 'Add Expense',
  },
  personalLiability: {
    id: 'fastCover.stepOther.personalLiability',
    defaultMessage: 'Personal Liability',
  },
  personalLiabilityMessage: {
    id: 'fastCover.stepOther.personalLiabilityMessage',
    defaultMessage: 'This section is for claims relating to your legal liability to pay damages or compensation to a third party for injury or property damage caused by you.',
  },
  personalAccident: {
    id: 'fastCover.stepOther.personalAccident',
    defaultMessage: 'Personal Accident',
  },
  personalAccidentMessage: {
    id: 'fastCover.stepOther.personalAccidentMessage',
    defaultMessage: 'This section is for claims related to loss of life, loss of income, or total disablement caused by an injury.',
  },
  personalAccidentParnerInsuranceInternationalMedicalOnlyNZMessage: {
    id: 'fastCover.stepOther.personalAccidentParnerInsuranceInternationalMedicalOnlyNZMessage',
    defaultMessage: 'This section is for claims related to loss of life caused by an injury.',
  },
  personalAccidentHeadersOnDomesticAUAndInternationalStudent: {
    id: 'fastCover.stepOther.personalAccidentHeadersOnDomesticAUAndInternationalStudent',
    defaultMessage: 'This section is for claims related to loss of life or total disablement caused by an injury.',
  },
  lossOfIncome: {
    id: 'fastCover.stepOther.lossOfIncome',
    defaultMessage: 'Loss of Income',
  },
  totalPermanentDisablement: {
    id: 'fastCover.stepOther.totalPermanentDisablement',
    defaultMessage: 'Total permanent disablement',
  },
  lossOfLife: {
    id: 'fastCover.stepOther.lossOfLife',
    defaultMessage: 'Loss of Life',
  },
  whatAreYourExpensesRelatedTo: {
    id: 'fastCover.stepOther.whatAreYourExpensesRelatedTo',
    defaultMessage: 'What are your expenses related to?',
  },
  thisSectionIsForClaimsRelatedToLossOfLifeCausedByAnInjury: {
    id: 'fastCover.stepOther.whatAreYourExpensesRelatedTo',
    defaultMessage: 'This section is for claims related to loss of life caused by an injury.',
  },
  selectInsuredForExpense: {
    id: 'fastCover.stepOther.selectInsuredForExpense',
    defaultMessage: 'Select the insured for this expense',
  },
  whatExpensesAreYouClaimingFor: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.whatExpensesAreYouClaimingFor',
    defaultMessage: 'What expenses are you claiming for?',
  },
  amountClaimExceedsMaximumDigits: {
    id: 'fastCover.baggageAndPersonalItemsSCTIStep.amountClaimExceedsMaximumDigits',
    defaultMessage: 'Amount Claimed exceeds the maximum allowable digits. Please enter a valid claim amount.',
  },
  dateYouWereOriginallyDueBackAtWork: {
    id: 'fastCover.stepOther.dateYouWereOriginallyDueBackAtWork',
    defaultMessage: 'Date you were originally due back at work',
  }
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepOther/messages.js